function tripTypeIcon(tripType) {
	if (!tripType) return 'flows';
	switch (tripType.toUpperCase()) {
	case 'L': //distribution
		return 'social-media';
	case 'EXTERNAL':
		return 'flow-linear';
	case 'N': //linehaul
	default:
		return 'flows';
	
	}
}

module.exports = tripTypeIcon;